import React from "react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../ui/select";

const SingleSelectNew = ({
  value,
  onChange,
  options = [],
  placeholder = "Select an option",
  disabled = false,
  className,
  tabIndex,
  contentClass,
  itemClass,
  inactive = false,
  allEmployees = { data: [] },
  zIndex
}) => {
  const handleItemClick = (option) => {
    const isInactiveLabel = option?.label === "Inactive Employee";
    onChange(option?.value);
  };

  return (
    <Select value={value} onValueChange={onChange} disabled={disabled}>
      <SelectTrigger
        disabled={disabled}
        className={`text-black placeholder-black dark:text-white dark:placeholder-white ${className}`}
        tabIndex={tabIndex}
      >
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent className={`${contentClass || "bg-white"}`} style={{ zIndex: zIndex ? zIndex : undefined }}>
        {options?.map((option) => {
          const employee = inactive
            ? allEmployees?.data?.find((emp) => emp.id === option?.value)
            : null;
          const isInactive = employee && employee.status === false;
          const isInactiveLabel = option.label === "Inactive Employee";
          const isNoShift = option?.value === "No Shift";

          const textStyle = isInactiveLabel
            ? "text-gray-400 italic"
            : isNoShift || option.disabled || option.locked
              ? "text-gray-400 italic"
              : isInactive
                ? "text-gray-400"
                : "";


          return (
            <SelectItem
              key={option.value}
              value={option.value}
              disabled={option.disabled}
              onClick={() => handleItemClick(option)}
              className={`${itemClass || ""} ${textStyle}`}
            >
              {isInactiveLabel ? (
                <span className="flex items-center">
                  {option.label}
                  <span className="text-green-700 ml-2">{">"}</span>
                </span>
              ) : (
                option.menuLabel ?? option.label
              )}
            </SelectItem>
          );
        })}
      </SelectContent>
    </Select>
  );
};

export default SingleSelectNew;
